export default __webpack_public_path__ + "static/media/picture3.d92ada3f.png";